/**
 * Where the Add Existing Person sheet was opened from. The entry point drives the sheet subtitle and
 * the wording of the Previous Relationships confirmation.
 */
export const ADD_EXISTING_PERSON_ENTRY_POINTS = {
  /** "Add Group Members" on a person's Relationships card — the group already exists. */
  RELATIONSHIPS_CARD: 'relationshipsCard',
  /** "Add Person to New Group" on the names panel — there is no focus person yet. */
  NEW_GROUP: 'newGroup',
}

/** Confirmation steps the flow can raise. Each maps to one route inside the flow's dialog. */
export const ADD_EXISTING_PERSON_STEPS = {
  PREVIOUS_RELATIONSHIPS: 'previousRelationships',
  PRIMARY_PERSON: 'primaryPerson',
}

/** Memory-router paths inside the flow's TransitioningDialogOverlay, one per step. */
export const ADD_EXISTING_PERSON_STEP_PATHS = {
  [ADD_EXISTING_PERSON_STEPS.PREVIOUS_RELATIONSHIPS]: '/previous-relationships',
  [ADD_EXISTING_PERSON_STEPS.PRIMARY_PERSON]: '/primary-person',
}

/** Form-value prefix for the sheet's name checkboxes. */
export const SELECTION_PREFIX = 'selectedPersons'

/** Form id for the Add Existing Person selection form. */
export const FORM_ID = 'add-existing-person-form'
